// app/(app)/inventory/units/add.tsx
import AppScreen from "@/components/default/AppScreen";
import { Button, Input } from "@/components/default/forms";
import { useAppTheme } from "@/hooks/useAppTheme";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { clearError, createUnit } from "@/store/slices/unitSlice";
import { router, useFocusEffect } from "expo-router";
import { useCallback, useEffect, useState } from "react";
import { Alert, ScrollView, StyleSheet, Text } from "react-native";

export default function AddUnitScreen() {
  const { colors, spacing } = useAppTheme();
  const dispatch = useAppDispatch();
  const { updating, error } = useAppSelector((state) => state.units);

  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [errors, setErrors] = useState({ name: "", symbol: "" });

  useFocusEffect(
    useCallback(() => {
      setName("");
      setSymbol("");
      setErrors({ name: "", symbol: "" });
      dispatch(clearError());
    }, []),
  );

  useEffect(() => {
    if (error) Alert.alert("Error", error);
  }, [error]);

  const validate = () => {
    let valid = true;
    const newErrors = { name: "", symbol: "" };
    if (!name.trim()) {
      newErrors.name = "Required";
      valid = false;
    }
    if (!symbol.trim()) {
      newErrors.symbol = "Required";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    const result = await dispatch(createUnit({ name, symbol }));
    if (createUnit.fulfilled.match(result)) {
      Alert.alert("Success", "Unit added", [
        { text: "OK", onPress: () => router.back() },
      ]);
    }
  };

  const styles = StyleSheet.create({
    container: { flex: 1, backgroundColor: colors.background },
    scrollContent: { padding: spacing.lg, paddingBottom: spacing.xl },
    title: {
      fontSize: 24,
      fontWeight: "600",
      color: colors.text,
      marginBottom: spacing.lg,
    },
    inputContainer: { marginBottom: spacing.lg },
  });

  return (
    <AppScreen>
      <ScrollView
        style={styles.container}
        contentContainerStyle={styles.scrollContent}
      >
        <Text style={styles.title}>Add Unit</Text>
        <Input
          label="Unit Name"
          value={name}
          onChangeText={setName}
          error={errors.name}
          containerStyle={styles.inputContainer}
          placeholder="e.g., Kilogram"
        />
        <Input
          label="Symbol"
          value={symbol}
          onChangeText={setSymbol}
          error={errors.symbol}
          containerStyle={styles.inputContainer}
          placeholder="e.g., kg"
        />
        <Button title="Save Unit" onPress={handleSubmit} loading={updating} />
      </ScrollView>
    </AppScreen>
  );
}
